import { Styles } from 'react-jss'

export const sheet: Styles = {
  link: {
    fontFamily: 'Roboto, sans-serif',
    textDecoration: 'none',
    fontWeight: 500,
    lineHeight: '21px',
    fontSize: 17,
    letterSpacing: '0.01em',
    textTransform: 'none',
    color: '#080910',
    padding: '10px 0',
    margin: '0 15px',
    cursor: 'pointer',
    '&:hover, &:focus': {
      textDecoration: 'underline',
      outline: 'none'
    }
  },

  '@media (min-width: 992px) and (max-width: 1199.98px)': {
    link: { padding: '6px 15px 5px' }
  },
  '@media (min-width: 768px) and (max-width: 991.98px)': {
    link: { padding: '6px 6px 5px' }
  },
  '@media (max-width: 992px)': {
    link: {
      display: 'block',
      // width: '100%',
      padding: '15px 10px',
      margin: 0,
      fontSize: 15,
      '& > a': {
        margin: '0 auto'
      }
    }
  }
}
